var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("normalDialog", {
    attrs: {
      title: _vm.$t("label_essweb_claimType_form_dialog_newNotice"),
      dialog: _vm.show,
      width: "600",
      scrollable: "",
    },
    on: { close: _vm.closeDialog },
    scopedSlots: _vm._u([
      {
        key: "content",
        fn: function () {
          return [
            _c(
              "v-form",
              { ref: "form", attrs: { "lazy-validation": "" } },
              [
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "12",
                          md: "12",
                          lg: "12",
                          cols: "12",
                        },
                      },
                      [
                        _c("inputTextFiledMultiLang", {
                          attrs: {
                            textArea: "",
                            bindData: _vm.notice,
                            TrigerInit: _vm.show,
                            maxlength: "500",
                            label: _vm.$t(
                              "label_essweb_claimType_form_dialog_noticeLabel"
                            ),
                            rules: _vm.$GetRules(["_Require_Rules"], [null]),
                          },
                          on: {
                            change: function (valueArr) {
                              _vm.notice = valueArr
                            },
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "actions",
        fn: function () {
          return [
            _c("CardActions", {
              attrs: { newBtn: "" },
              on: { new: _vm.toNew, cancel: _vm.closeDialog },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }